module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaLight-Regular.4355de4b.ttf";